import { templateApi as api } from "../../openapi/templateApi";
var injectedRtkApi = api.injectEndpoints({
    endpoints: function (build) { return ({
        createPlace: build.mutation({
            query: function (queryArg) { return ({
                url: "/api/v1/places",
                method: "POST",
                body: queryArg.createPlaceDto,
            }); },
        }),
        getPlaces: build.query({
            query: function (queryArg) { return ({
                url: "/api/v1/places",
                params: { limit: queryArg.limit, page: queryArg.page },
            }); },
        }),
        getPlaceById: build.query({
            query: function (queryArg) { return ({ url: "/api/v1/places/".concat(queryArg.id) }); },
        }),
        updatePlace: build.mutation({
            query: function (queryArg) { return ({
                url: "/api/v1/places/".concat(queryArg.id),
                method: "PATCH",
                body: queryArg.updatePlaceDto,
            }); },
        }),
        deletePlace: build.mutation({
            query: function (queryArg) { return ({
                url: "/api/v1/places/".concat(queryArg.id),
                method: "DELETE",
            }); },
        }),
        getPlaceSchedules: build.query({
            query: function (queryArg) { return ({ url: "/api/v1/places/".concat(queryArg.id, "/schedules") }); },
        }),
        updateRankPlaceSchedules: build.mutation({
            query: function (queryArg) { return ({
                url: "/api/v1/places/".concat(queryArg.id, "/schedules"),
                method: "PATCH",
                body: queryArg.body,
            }); },
        }),
        getPlaceSlots: build.query({
            query: function (queryArg) { return ({
                url: "/api/v1/places/".concat(queryArg.id, "/slots"),
                params: { startDate: queryArg.startDate, stopDate: queryArg.stopDate },
            }); },
        }),
        addPlaceToFavorites: build.mutation({
            query: function (queryArg) { return ({
                url: "/api/v1/places/favorites/".concat(queryArg.favoriteId),
                method: "POST",
            }); },
        }),
        removePlaceFromFavorites: build.mutation({
            query: function (queryArg) { return ({
                url: "/api/v1/places/favorites/".concat(queryArg.favoriteId),
                method: "DELETE",
            }); },
        }),
        getPlaceFavorites: build.query({
            query: function (queryArg) { return ({
                url: "/api/v1/places/favorites/list",
                params: {
                    text: queryArg.text,
                    limit: queryArg.limit,
                    page: queryArg.page,
                },
            }); },
        }),
        getPlaceGames: build.query({
            query: function (queryArg) { return ({
                url: "/api/v1/places/".concat(queryArg.id, "/games"),
                params: {
                    page: queryArg.page,
                    limit: queryArg.limit,
                    startDate: queryArg.startDate,
                    stopDate: queryArg.stopDate,
                    timeframe: queryArg.timeframe,
                },
            }); },
        }),
        createGameForSlot: build.mutation({
            query: function (queryArg) { return ({
                url: "/api/v1/games/".concat(queryArg.placeId, "/slot/").concat(queryArg.slotId, "/").concat(queryArg.date),
                method: "POST",
            }); },
        }),
        createGameForCustomSlot: build.mutation({
            query: function (queryArg) { return ({
                url: "/api/v1/games/".concat(queryArg.placeId, "/customslot"),
                method: "POST",
                body: queryArg.createGameDto,
            }); },
        }),
        updateGame: build.mutation({
            query: function (queryArg) { return ({
                url: "/api/v1/games/".concat(queryArg.id),
                method: "PATCH",
                body: queryArg.updateGameDto,
            }); },
        }),
        deleteGame: build.mutation({
            query: function (queryArg) { return ({
                url: "/api/v1/games/".concat(queryArg.id),
                method: "DELETE",
            }); },
        }),
        getGameById: build.query({
            query: function (queryArg) { return ({ url: "/api/v1/games/".concat(queryArg.id) }); },
        }),
        getGames: build.query({
            query: function (queryArg) { return ({
                url: "/api/v1/games",
                params: {
                    page: queryArg.page,
                    limit: queryArg.limit,
                    startDate: queryArg.startDate,
                    stopDate: queryArg.stopDate,
                    timeframe: queryArg.timeframe,
                },
            }); },
        }),
        acceptInvite: build.mutation({
            query: function (queryArg) { return ({
                url: "/api/v1/games/".concat(queryArg.id, "/accept"),
                method: "PATCH",
            }); },
        }),
        rejectInvite: build.mutation({
            query: function (queryArg) { return ({
                url: "/api/v1/games/".concat(queryArg.id, "/reject"),
                method: "PATCH",
            }); },
        }),
        requestJoin: build.mutation({
            query: function (queryArg) { return ({
                url: "/api/v1/games/".concat(queryArg.id, "/request"),
                method: "PATCH",
            }); },
        }),
        declineJoin: build.mutation({
            query: function (queryArg) { return ({
                url: "/api/v1/games/".concat(queryArg.id, "/decline/").concat(queryArg.userId),
                method: "PATCH",
            }); },
        }),
        allowJoin: build.mutation({
            query: function (queryArg) { return ({
                url: "/api/v1/games/".concat(queryArg.id, "/allow/").concat(queryArg.userId),
                method: "PATCH",
            }); },
        }),
        unJoin: build.mutation({
            query: function (queryArg) { return ({
                url: "/api/v1/games/".concat(queryArg.id, "/unjoin"),
                method: "PATCH",
            }); },
        }),
        join: build.mutation({
            query: function (queryArg) { return ({
                url: "/api/v1/games/".concat(queryArg.id, "/join"),
                method: "PATCH",
            }); },
        }),
        extendReservation: build.mutation({
            query: function (queryArg) { return ({
                url: "/api/v1/games/".concat(queryArg.id, "/extend-reservation"),
                method: "PATCH",
                body: queryArg.extendReservationDto,
            }); },
        }),
        cancelReservation: build.mutation({
            query: function (queryArg) { return ({
                url: "/api/v1/games/".concat(queryArg.id, "/reservation"),
                method: "DELETE",
            }); },
        }),
        getUserById: build.query({
            query: function (queryArg) { return ({ url: "/api/v1/users/".concat(queryArg.id) }); },
        }),
        deleteUser: build.mutation({
            query: function (queryArg) { return ({
                url: "/api/v1/users/".concat(queryArg.id),
                method: "DELETE",
            }); },
        }),
        updateUser: build.mutation({
            query: function (queryArg) { return ({
                url: "/api/v1/users/".concat(queryArg.id),
                method: "PATCH",
                body: queryArg.userUpdateDto,
            }); },
        }),
        linkAuthUser: build.mutation({
            query: function (queryArg) { return ({
                url: "/api/v1/users",
                method: "POST",
                body: queryArg.userAuthLinkDto,
            }); },
        }),
        getUsers: build.query({
            query: function (queryArg) { return ({
                url: "/api/v1/users",
                params: {
                    text: queryArg.text,
                    limit: queryArg.limit,
                    page: queryArg.page,
                },
            }); },
        }),
        deepLink: build.mutation({
            query: function () { return ({ url: "/api/v1/users/deepLink", method: "POST" }); },
        }),
        removeTgLink: build.mutation({
            query: function () { return ({ url: "/api/v1/users/removeTgLink", method: "PATCH" }); },
        }),
        addUserToFavorites: build.mutation({
            query: function (queryArg) { return ({
                url: "/api/v1/users/favorites/".concat(queryArg.favoriteId),
                method: "POST",
            }); },
        }),
        removeUserFromFavorites: build.mutation({
            query: function (queryArg) { return ({
                url: "/api/v1/users/favorites/".concat(queryArg.favoriteId),
                method: "DELETE",
            }); },
        }),
        getUserFavorites: build.query({
            query: function (queryArg) { return ({
                url: "/api/v1/users/favorites/list",
                params: {
                    text: queryArg.text,
                    limit: queryArg.limit,
                    page: queryArg.page,
                },
            }); },
        }),
        getUserGames: build.query({
            query: function (queryArg) { return ({
                url: "/api/v1/users/".concat(queryArg.id, "/games"),
                params: {
                    page: queryArg.page,
                    limit: queryArg.limit,
                    startDate: queryArg.startDate,
                    stopDate: queryArg.stopDate,
                    timeframe: queryArg.timeframe,
                    memberStatuses: queryArg.memberStatuses,
                },
            }); },
        }),
        getScheduleById: build.query({
            query: function (queryArg) { return ({ url: "/api/v1/schedules/".concat(queryArg.id) }); },
        }),
        updateSchedule: build.mutation({
            query: function (queryArg) { return ({
                url: "/api/v1/schedules/".concat(queryArg.id),
                method: "PATCH",
                body: queryArg.updateScheduleDto,
            }); },
        }),
        deleteSchedule: build.mutation({
            query: function (queryArg) { return ({
                url: "/api/v1/schedules/".concat(queryArg.id),
                method: "DELETE",
            }); },
        }),
        createSchedule: build.mutation({
            query: function (queryArg) { return ({
                url: "/api/v1/schedules",
                method: "POST",
                body: queryArg.createScheduleDto,
            }); },
        }),
        createSport: build.mutation({
            query: function (queryArg) { return ({
                url: "/api/v1/sports",
                method: "POST",
                body: queryArg.createSportDto,
            }); },
        }),
        getSports: build.query({
            query: function (queryArg) { return ({
                url: "/api/v1/sports",
                params: {
                    text: queryArg.text,
                    limit: queryArg.limit,
                    page: queryArg.page,
                },
            }); },
        }),
        getSportById: build.query({
            query: function (queryArg) { return ({ url: "/api/v1/sports/".concat(queryArg.id) }); },
        }),
        updateSport: build.mutation({
            query: function (queryArg) { return ({
                url: "/api/v1/sports/".concat(queryArg.id),
                method: "PATCH",
                body: queryArg.updateSportDto,
            }); },
        }),
        deleteSport: build.mutation({
            query: function (queryArg) { return ({
                url: "/api/v1/sports/".concat(queryArg.id),
                method: "DELETE",
            }); },
        }),
        createCity: build.mutation({
            query: function (queryArg) { return ({
                url: "/api/v1/cities",
                method: "POST",
                body: queryArg.createCityDto,
            }); },
        }),
        getCities: build.query({
            query: function (queryArg) { return ({
                url: "/api/v1/cities",
                params: {
                    text: queryArg.text,
                    limit: queryArg.limit,
                    page: queryArg.page,
                },
            }); },
        }),
        getCityById: build.query({
            query: function (queryArg) { return ({ url: "/api/v1/cities/".concat(queryArg.id) }); },
        }),
        updateCity: build.mutation({
            query: function (queryArg) { return ({
                url: "/api/v1/cities/".concat(queryArg.id),
                method: "PATCH",
                body: queryArg.updateCityDto,
            }); },
        }),
        deleteCity: build.mutation({
            query: function (queryArg) { return ({
                url: "/api/v1/cities/".concat(queryArg.id),
                method: "DELETE",
            }); },
        }),
        uploadAvatar: build.mutation({
            query: function (queryArg) { return ({
                url: "/api/v1/upload/avatar",
                method: "POST",
                body: queryArg.body,
            }); },
        }),
        uploadCover: build.mutation({
            query: function (queryArg) { return ({
                url: "/api/v1/upload/cover",
                method: "POST",
                body: queryArg.body,
            }); },
        }),
    }); },
    overrideExisting: false,
});
export { injectedRtkApi as api };
export var ScheduleStatus;
(function (ScheduleStatus) {
    ScheduleStatus["Active"] = "ACTIVE";
    ScheduleStatus["Disabled"] = "DISABLED";
})(ScheduleStatus || (ScheduleStatus = {}));
export var WorkTimeMode;
(function (WorkTimeMode) {
    WorkTimeMode["Timegrid"] = "TIMEGRID";
    WorkTimeMode["Custom"] = "CUSTOM";
    WorkTimeMode["Daily"] = "DAILY";
    WorkTimeMode["None"] = "NONE";
})(WorkTimeMode || (WorkTimeMode = {}));
export var GameStatus;
(function (GameStatus) {
    GameStatus["Draft"] = "DRAFT";
    GameStatus["Aproved"] = "APROVED";
})(GameStatus || (GameStatus = {}));
export var GameUserRole;
(function (GameUserRole) {
    GameUserRole["Member"] = "MEMBER";
    GameUserRole["Creator"] = "CREATOR";
})(GameUserRole || (GameUserRole = {}));
export var GameUserStatus;
(function (GameUserStatus) {
    GameUserStatus["Invited"] = "INVITED";
    GameUserStatus["Confirmed"] = "CONFIRMED";
    GameUserStatus["Rejected"] = "REJECTED";
    GameUserStatus["Requested"] = "REQUESTED";
    GameUserStatus["Allowed"] = "ALLOWED";
    GameUserStatus["Declined"] = "DECLINED";
})(GameUserStatus || (GameUserStatus = {}));
export var GameLevel;
(function (GameLevel) {
    GameLevel["Easy"] = "EASY";
    GameLevel["Medium"] = "MEDIUM";
    GameLevel["Hard"] = "HARD";
})(GameLevel || (GameLevel = {}));
export var RequestMode;
(function (RequestMode) {
    RequestMode["Private"] = "PRIVATE";
    RequestMode["Moderate"] = "MODERATE";
    RequestMode["Public"] = "PUBLIC";
})(RequestMode || (RequestMode = {}));
export var GameTimeFrame;
(function (GameTimeFrame) {
    GameTimeFrame["Upcoming"] = "UPCOMING";
    GameTimeFrame["Past"] = "PAST";
    GameTimeFrame["All"] = "ALL";
})(GameTimeFrame || (GameTimeFrame = {}));
export var CalendarRepeatMode;
(function (CalendarRepeatMode) {
    CalendarRepeatMode["Once"] = "ONCE";
    CalendarRepeatMode["Daily"] = "DAILY";
    CalendarRepeatMode["Weekly"] = "WEEKLY";
    CalendarRepeatMode["Calenddays"] = "CALENDDAYS";
    CalendarRepeatMode["Weekdays"] = "WEEKDAYS";
})(CalendarRepeatMode || (CalendarRepeatMode = {}));
export var useCreatePlaceMutation = injectedRtkApi.useCreatePlaceMutation, useGetPlacesQuery = injectedRtkApi.useGetPlacesQuery, useGetPlaceByIdQuery = injectedRtkApi.useGetPlaceByIdQuery, useUpdatePlaceMutation = injectedRtkApi.useUpdatePlaceMutation, useDeletePlaceMutation = injectedRtkApi.useDeletePlaceMutation, useGetPlaceSchedulesQuery = injectedRtkApi.useGetPlaceSchedulesQuery, useUpdateRankPlaceSchedulesMutation = injectedRtkApi.useUpdateRankPlaceSchedulesMutation, useGetPlaceSlotsQuery = injectedRtkApi.useGetPlaceSlotsQuery, useAddPlaceToFavoritesMutation = injectedRtkApi.useAddPlaceToFavoritesMutation, useRemovePlaceFromFavoritesMutation = injectedRtkApi.useRemovePlaceFromFavoritesMutation, useGetPlaceFavoritesQuery = injectedRtkApi.useGetPlaceFavoritesQuery, useGetPlaceGamesQuery = injectedRtkApi.useGetPlaceGamesQuery, useCreateGameForSlotMutation = injectedRtkApi.useCreateGameForSlotMutation, useCreateGameForCustomSlotMutation = injectedRtkApi.useCreateGameForCustomSlotMutation, useUpdateGameMutation = injectedRtkApi.useUpdateGameMutation, useDeleteGameMutation = injectedRtkApi.useDeleteGameMutation, useGetGameByIdQuery = injectedRtkApi.useGetGameByIdQuery, useGetGamesQuery = injectedRtkApi.useGetGamesQuery, useAcceptInviteMutation = injectedRtkApi.useAcceptInviteMutation, useRejectInviteMutation = injectedRtkApi.useRejectInviteMutation, useRequestJoinMutation = injectedRtkApi.useRequestJoinMutation, useDeclineJoinMutation = injectedRtkApi.useDeclineJoinMutation, useAllowJoinMutation = injectedRtkApi.useAllowJoinMutation, useUnJoinMutation = injectedRtkApi.useUnJoinMutation, useJoinMutation = injectedRtkApi.useJoinMutation, useExtendReservationMutation = injectedRtkApi.useExtendReservationMutation, useCancelReservationMutation = injectedRtkApi.useCancelReservationMutation, useGetUserByIdQuery = injectedRtkApi.useGetUserByIdQuery, useDeleteUserMutation = injectedRtkApi.useDeleteUserMutation, useUpdateUserMutation = injectedRtkApi.useUpdateUserMutation, useLinkAuthUserMutation = injectedRtkApi.useLinkAuthUserMutation, useGetUsersQuery = injectedRtkApi.useGetUsersQuery, useDeepLinkMutation = injectedRtkApi.useDeepLinkMutation, useRemoveTgLinkMutation = injectedRtkApi.useRemoveTgLinkMutation, useAddUserToFavoritesMutation = injectedRtkApi.useAddUserToFavoritesMutation, useRemoveUserFromFavoritesMutation = injectedRtkApi.useRemoveUserFromFavoritesMutation, useGetUserFavoritesQuery = injectedRtkApi.useGetUserFavoritesQuery, useGetUserGamesQuery = injectedRtkApi.useGetUserGamesQuery, useGetScheduleByIdQuery = injectedRtkApi.useGetScheduleByIdQuery, useUpdateScheduleMutation = injectedRtkApi.useUpdateScheduleMutation, useDeleteScheduleMutation = injectedRtkApi.useDeleteScheduleMutation, useCreateScheduleMutation = injectedRtkApi.useCreateScheduleMutation, useCreateSportMutation = injectedRtkApi.useCreateSportMutation, useGetSportsQuery = injectedRtkApi.useGetSportsQuery, useGetSportByIdQuery = injectedRtkApi.useGetSportByIdQuery, useUpdateSportMutation = injectedRtkApi.useUpdateSportMutation, useDeleteSportMutation = injectedRtkApi.useDeleteSportMutation, useCreateCityMutation = injectedRtkApi.useCreateCityMutation, useGetCitiesQuery = injectedRtkApi.useGetCitiesQuery, useGetCityByIdQuery = injectedRtkApi.useGetCityByIdQuery, useUpdateCityMutation = injectedRtkApi.useUpdateCityMutation, useDeleteCityMutation = injectedRtkApi.useDeleteCityMutation, useUploadAvatarMutation = injectedRtkApi.useUploadAvatarMutation, useUploadCoverMutation = injectedRtkApi.useUploadCoverMutation;
